import React from 'react';
import { NavLink } from 'react-router-dom';

export default ({ products }) => {
  if (!products || products.length === 0) return null;
  return (
    <ul className="main-nav no-print">
      {products.map((item, index) => {
        if (typeof item === 'function') {
          return (
            <li className="nav-button" key={index}>
              {item()}
            </li>
          );
        }

        return (
          <li key={index}>
            <NavLink
              exact={item.url === '/' || item.exact}
              activeClassName="selected"
              to={item.url}
            >
              {item.label}
            </NavLink>
          </li>
        );
      })}
    </ul>
  );
};
